import React from 'react'
import CustomizedTimeline from '../../components/Timeline/Timeline'

const Notebook = () => {
  return (
    <div>
      <CustomizedTimeline></CustomizedTimeline>
    </div>
  )
}

export default Notebook